import { useMemo } from 'react';
import { useIsPhone, useIsMobile } from './useIsMobile';

/**
 * Filters DataGrid columns based on screen size.
 *
 * Usage: Add `mobile: false` to columns that should be hidden on phones,
 *        and `tablet: false` for columns hidden on tablets too.
 *
 * Example:
 *   const columns = [
 *     { field: 'Name', headerName: 'שם', flex: 1 },           // Always visible
 *     { field: 'Email', headerName: 'אימייל', flex: 1, mobile: false },  // Hidden on phone
 *     { field: 'Notes', headerName: 'הערות', flex: 1, tablet: false },    // Hidden on phone+tablet
 *   ];
 *   const responsiveColumns = useResponsiveColumns(columns);
 */
export const useResponsiveColumns = (columns) => {
  const isPhone = useIsPhone();
  const isMobile = useIsMobile();

  return useMemo(() => {
    if (isPhone) {
      return columns
        .filter((col) => col.mobile !== false)
        .map((col) => ({
          ...col,
          flex: col.mobileFlex ?? col.flex,
          minWidth: col.mobileMinWidth ?? col.minWidth,
        }));
    }
    if (isMobile) {
      return columns.filter((col) => col.tablet !== false);
    }
    return columns;
  }, [columns, isPhone, isMobile]);
};
